<template>
    <v-container>

		<v-row>
			<v-col cols="12">
				<v-row
					align="center"
					justify="center"
					class="grey lighten-5"
				>
					<v-card
						v-for="(date, key) in devicesInfo"
						:key="key"
						class="ma-3"
						max-width="300"
						min-width="300"
						outlined
					>
						<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title class="headline">
								{{getDeviceName(key)}}
								<v-btn
									class="float-md-right"
									v-if="userType"
									color="error"
									icon
									@click="removeDevice(key)"
								>
									<v-icon>mdi-toy-brick-remove-outline</v-icon>
								</v-btn>
							</v-list-item-title>
							<v-list-item-subtitle>{{date | dateFormat}}</v-list-item-subtitle>
						</v-list-item-content>
						</v-list-item>

						<v-divider></v-divider>

						<v-card-actions >
							<v-row align="center" justify="center">
								<v-btn text @click="goSensor(key)" v-show="isDev"> Sensor </v-btn>
								<v-btn text @click="goLaeq(key)" :disabled="!hasLaeq(key)"> Sonido </v-btn>
								<v-btn text disabled> Log </v-btn>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-row>
			</v-col>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Devices',

		data: () => ({
			items: [
				{ title: 'Delete' },
			],
		}),
		
		methods: {
			alarmSensor (device) {
				return ''
			},

			hasLaeq (id) {
				const devices = this.devices.find( e => {
					return e.deviceId === id
				})
				
				if (devices === undefined)
					return false
				
				const sensors = devices.sensors
				const hasLaeq = (element) => element.sensorType === "laeq";
				return sensors.some(hasLaeq)
			},

			goSensor (deviceId) {
				this.$router.push('/sensor/' + deviceId)
			},

			goLaeq (deviceId) {
				this.$router.push('/laeq/' + deviceId)
			},

			removeDevice (deviceId) {
				const payload = {
					deviceId: deviceId
				}

		        this.$store.dispatch('removeDevice', payload)
			},

			getDeviceName (deviceId) {
				let device = this.devices.find( e => {
					return e.deviceId === deviceId
				})

				return device === undefined ? '' : device.name
			},
		},

		computed: {
			userType () {
				return false
			},

			devices () {
				return this.$store.getters.devices
			},

			devicesInfo () {
				return this.$store.getters.devicesInfo
			},
			user () {
                return this.$store.getters.user
            },
            isDev () {
                return this.user.roles.some( e => {
                    return e.name === 'dev'
                })
			}
		},

		filters : {
			dateFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LLL')
			},
		},

		created () {
			this.$store.dispatch('pullInfoDevices')
			moment.locale('es-us')
		}

	}
</script>
